var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { TagsService } from '../../services';
import { of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material';
import { map, startWith } from 'rxjs/operators';
import find from 'lodash/find';
import { ToasterService } from 'angular2-toaster';
var AppTagsComponent = /** @class */ (function () {
    function AppTagsComponent(tagsService, toasterService) {
        this.tagsService = tagsService;
        this.toasterService = toasterService;
        // Tags suggestion management
        this.allTags = [];
        this.myControl = new FormControl();
        this.inputHasFocus = false;
        this.tags = [];
        this.results = null;
        this.notify = new EventEmitter();
        this.onTagClick = new EventEmitter();
        this.onTagRemove = new EventEmitter();
        this.placeholder = 'Insert tags here';
        this.overrideClass = '';
    }
    AppTagsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Filter tags suggestion
        this.filteredOptions = this.myControl.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    AppTagsComponent.prototype.updateAutoComplete = function () {
        var _this = this;
        var obs = this.tagsService.getTags();
        if (this.results && Array.isArray(this.results)) {
            obs = of(this.results);
        }
        // Get Tags
        obs
            .subscribe(function (allTags) {
            _this.allTags = allTags;
            // remove existing tags from autocomplete
            for (var _i = 0, _a = _this.tags; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagToFind = find(_this.allTags, { 'id': tag['id'] });
                if (tagToFind !== undefined) {
                    _this.allTags.splice(_this.allTags.indexOf(tagToFind), 1);
                }
            }
            _this.myControl.setValue(_this.textInput.nativeElement.value);
            _this.autocomplete.updatePosition();
            if (_this.inputHasFocus) {
                _this.autocomplete.openPanel();
            }
        });
    };
    // Filter function for tags suggestion
    AppTagsComponent.prototype._filter = function (value) {
        if (typeof value === 'string' && this.allTags) {
            var filterValue_1 = value.toLowerCase();
            return this.allTags.filter(function (option) { return option.name.toLowerCase().includes(filterValue_1); });
        }
    };
    AppTagsComponent.prototype.addTagFromInput = function ($event) {
        this.inputHasFocus = false;
        var inputVal = $event['target'].value;
        // Check if value is not empty and comes from 'blur' or 'Enter keypress' events
        if (inputVal.replace(/\s/g, '').length && ($event['key'] === 'Enter' || $event['type'] === 'blur')) {
            var keyAlreadyExisting = find(this.tags, { 'name': inputVal }) !== undefined;
            if (!keyAlreadyExisting && !this.isFilter) {
                // call API
                var tagToAdd = { 'name': inputVal };
                this.tags.push(tagToAdd);
                if (!this.isFilter) {
                    this.addTag([tagToAdd]);
                }
                // reset input and close autocomplete
                $event['target'].value = '';
                this.myControl.reset();
                this.autocomplete.closePanel();
            }
        }
    };
    AppTagsComponent.prototype.onTagSelect = function (optionObj) {
        var optionName = optionObj['option'].viewValue;
        var optionId = optionObj['option'].value;
        var keyAlreadyExisting = find(this.tags, { 'id': optionId }) !== undefined;
        if (!keyAlreadyExisting) {
            var tagToAdd = { 'id': optionId, 'name': optionName };
            this.tags.push(tagToAdd);
            if (!this.isFilter) {
                this.addTag([tagToAdd]);
            }
            tagToAdd['action'] = 'add';
            this.notify.emit(tagToAdd);
            // reset text input
            this.textInput.nativeElement.value = '';
        }
        else {
            this.myControl.setValue(optionName);
            this.textInput.nativeElement.value = optionName;
        }
    };
    AppTagsComponent.prototype.addTag = function (tagsToAdd) {
        return __awaiter(this, void 0, void 0, function () {
            var addedTags, _i, addedTags_1, tag, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!this.createTagService) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createTagService(tagsToAdd[0]['name'])];
                    case 1:
                        addedTags = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.tagsService.saveTags(this.entity_id, tagsToAdd, this.type).toPromise()];
                    case 3:
                        addedTags = _a.sent();
                        for (_i = 0, addedTags_1 = addedTags; _i < addedTags_1.length; _i++) {
                            tag = addedTags_1[_i];
                            find(this.tags, { 'name': tag.name }).id = tag.id;
                        }
                        _a.label = 4;
                    case 4:
                        this.updateAutoComplete();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.toasterService.pop('error', 'Error', 'Error saving tags. Please try again.');
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AppTagsComponent.prototype.removeTag = function (tag) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.tagsService.deleteTags(this.entity_id, [{ id: tag['id'] }]);
                        if (!!this.isFilter) return [3 /*break*/, 9];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!(this.deleteTagService !== null)) return [3 /*break*/, 4];
                        if (!tag.id) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.deleteTagService(tag.id)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, promise.toPromise()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.tags.splice(this.tags.indexOf(tag), 1);
                        this.updateAutoComplete();
                        if (this.onTagRemove) {
                            this.onTagRemove.emit();
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.toasterService.pop('error', 'Error', 'Error removing tag. Please try again.');
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        this.tags.splice(this.tags.indexOf(tag), 1);
                        tag['action'] = 'remove';
                        this.notify.emit(tag);
                        this.updateAutoComplete();
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    return AppTagsComponent;
}());
export { AppTagsComponent };
